import { render, staticRenderFns } from "./JifenGiveForm.vue?vue&type=template&id=9195f24a&scoped=true"
import script from "./JifenGiveForm.vue?vue&type=script&lang=js"
export * from "./JifenGiveForm.vue?vue&type=script&lang=js"
import style0 from "./JifenGiveForm.vue?vue&type=style&index=0&id=9195f24a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9195f24a",
  null
  
)

export default component.exports